<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <!-- 加载中 -->
    <div v-if="isInitializing" class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p class="text-gray-600">加载中...</p>
      </div>
    </div>

    <!-- 应用主体 -->
    <router-view v-else />

    <!-- 全局提示 -->
    <div
      v-if="globalMessage"
      :class="[
        'fixed top-4 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-lg shadow-lg z-50 transition-all duration-300',
        globalMessage.type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
      ]"
    >
      {{ globalMessage.text }}
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useAuthStore } from './stores/auth'
import { useConfigStore } from './stores/config'

const authStore = useAuthStore()
const configStore = useConfigStore()
const isInitializing = ref(true)
const globalMessage = ref(null)

onMounted(async () => {
  try {
    // 检查并清除无效token
    let token = localStorage.getItem('token')
    if (token) {
      try {
        // 简单验证token格式 - 支持JWT格式和普通token
        if (token.includes('.')) {
          // JWT 格式，验证 payload
          const parts = token.split('.')
          if (parts.length === 3 && parts[1]) {
            const payload = JSON.parse(atob(parts[1]))
            if (payload.exp && payload.exp * 1000 < Date.now()) {
              localStorage.removeItem('token')
              localStorage.removeItem('user')
              token = null
            }
          }
        } else {
          // 非JWT格式的token，保留原样
        }
      } catch (e) {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        token = null
      }
    }

    // 只有在有有效token时才加载配置
    if (token && configStore.campuses.length === 0) {
      await configStore.fetchConfigs()
    }
  } catch (error) {
    console.error('❌ [App] 配置数据加载失败:', error)
  } finally {
    isInitializing.value = false
  }
})
</script>

<style>
/* 全局样式 */
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 移动端适配 */
* {
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
</style>
